import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const SyncIcon = ({
  color = RoutalPalette.secondary60,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" style={{ ...props.style }}>
      <g fill="none">
        <path
          d="M3.33398 10C3.33398 5.85787 6.69182 2.5 10.834 2.5C13.6795 2.5 16.1549 4.08464 17.4258 6.41958M17.4258 6.41958L17.8219 6.41958L17.8219 3.47331M17.4258 6.41958L14.8757 6.41958M18.334 10C18.334 14.1422 14.9761 17.5 10.834 17.5C7.98848 17.5 5.51307 15.9153 4.24215 13.5804M4.24215 13.5804L3.84607 13.5804L3.84607 16.5267M4.24215 13.5804L6.79232 13.5804"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
